import {createContext} from 'react';

type CreateForContractHolderStepDisplayVariant = 'default' | 'verbose';

type NewDocumentCreationDialogContext = {
  createForContractHolderStepDisplayVariant: CreateForContractHolderStepDisplayVariant;
  isDialogVisible: boolean;
  showDialog: (onClose?: () => void) => void;
  hideDialog: () => void;
  isConfirmationDialogVisible: boolean;
  showConfirmationDialog: () => void;
  hideConfirmationDialog: () => void;
};

export const NewDocumentCreationContext = createContext<NewDocumentCreationDialogContext | undefined>(undefined);
